// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.f9sb8HA__y4HtpWuelug{height:100%;overflow:auto}.C0ciyhxMhawS4BL9K7TY{grid-template-rows:34px 16px minmax(180px,max-content);width:760px;height:100%;margin:0 auto;padding:64px 20px 0;display:grid}.kcbNwwMyHDATUljzcVK3{margin-left:4px}.waoHHcSrf2EOttzZOVKO{align-items:start;margin-right:4px;display:flex}.rA2o7FThvsqh4GXtklnr{margin-left:4px;margin-right:4px}.tKJRZZJW518ciTXguLjh{margin:0 2px}.pIHkyn_8eggmer8JzDYh{margin-right:8px}.t6CjMwbZfKc4FpNlZ0em{align-items:center;display:flex}.zhOa5JmJTEcPTj1Hc3ll{flex-direction:column;gap:24px;display:flex}.h54MPpeeBW01m3mkix3f{margin-bottom:0!important}.z6wrekud4jspGXJGFKE_ .CV6JfHqCGKkr6IeWA0Wc{align-items:center;display:flex}.z6wrekud4jspGXJGFKE_ .W94io5KNaZohdQGZQLXu{margin-left:4px;text-decoration:none}.z6wrekud4jspGXJGFKE_ .W94io5KNaZohdQGZQLXu :hover{color:var(--content-brand-secondary)}.z6wrekud4jspGXJGFKE_ .eLIDEaTyrjkLn15pLjQG{color:var(--content-brand-primary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `f9sb8HA__y4HtpWuelug`,
	"content": `C0ciyhxMhawS4BL9K7TY`,
	"editBtn": `kcbNwwMyHDATUljzcVK3`,
	"tollFreeVerificationDesc": `waoHHcSrf2EOttzZOVKO`,
	"flag": `rA2o7FThvsqh4GXtklnr`,
	"arrow": `tKJRZZJW518ciTXguLjh`,
	"sectionTitleText": `pIHkyn_8eggmer8JzDYh`,
	"sectionTitle": `t6CjMwbZfKc4FpNlZ0em`,
	"sections": `zhOa5JmJTEcPTj1Hc3ll`,
	"sectionNoMargin": `h54MPpeeBW01m3mkix3f`,
	"customDesc": `z6wrekud4jspGXJGFKE_`,
	"descSubtext": `CV6JfHqCGKkr6IeWA0Wc`,
	"learnMoreLink": `W94io5KNaZohdQGZQLXu`,
	"learnMoreText": `eLIDEaTyrjkLn15pLjQG`
};
export default ___CSS_LOADER_EXPORT___;
